export const chartDataByItem: Record<string, { line: number[]; bar: number[] }> = {
  ITM001: {
    line: [
      117, 94, 37, 59, 89, 54, 79, 52, 15, 31, 53, 100, 32, 88, 67, 111, 20, 52, 37, 36, 50, 48,
      119, 61,
    ],
    bar: [
      54, 30, 19, 50, 85, 56, 64, 69, 77, 96, 20, 0, 65, 37, 43, 16, 50, 10, 14, 84, 72, 76, 46, 85,
    ],
  },
  ITM002: {
    line: [
      118, 78, 40, 43, 115, 19, 62, 95, 25, 84, 105, 35, 81, 112, 59, 110, 18, 36, 59, 115, 71, 47,
      91, 46,
    ],
    bar: [
      70, 25, 44, 38, 81, 71, 20, 56, 34, 9, 23, 24, 49, 54, 7, 15, 6, 78, 28, 78, 44, 9, 17, 17,
    ],
  },
  ITM003: {
    line: [
      80, 38, 118, 84, 80, 51, 63, 35, 104, 17, 11, 19, 99, 119, 36, 98, 90, 101, 59, 118, 44, 74,
      96, 69,
    ],
    bar: [
      93, 32, 42, 22, 73, 78, 19, 32, 36, 43, 59, 26, 7, 85, 72, 89, 25, 35, 82, 95, 100, 22, 15,
      53,
    ],
  },
  ITM004: {
    line: [
      48, 111, 38, 16, 25, 90, 60, 37, 99, 64, 76, 33, 99, 61, 90, 110, 31, 50, 14, 12, 10, 67, 103,
      73,
    ],
    bar: [
      24, 64, 43, 51, 5, 73, 91, 22, 34, 64, 55, 3, 97, 81, 64, 80, 50, 70, 92, 42, 19, 52, 35, 69,
    ],
  },
  ITM005: {
    line: [
      21, 71, 26, 22, 88, 77, 34, 61, 24, 69, 91, 104, 88, 38, 90, 89, 119, 80, 106, 118, 51, 54,
      83, 72,
    ],
    bar: [
      66, 47, 45, 1, 13, 23, 35, 70, 44, 41, 45, 91, 62, 14, 9, 62, 37, 69, 14, 40, 94, 96, 25, 2,
    ],
  },
  ITM006: {
    line: [
      119, 89, 55, 68, 77, 83, 53, 89, 113, 23, 101, 25, 79, 45, 107, 19, 50, 67, 41, 82, 62, 45,
      75, 80,
    ],
    bar: [
      35, 18, 42, 18, 6, 75, 44, 69, 78, 36, 72, 10, 64, 98, 6, 69, 84, 25, 60, 23, 66, 14, 27, 70,
    ],
  },
  ITM007: {
    line: [
      63, 80, 70, 46, 85, 96, 26, 84, 88, 42, 117, 37, 82, 65, 13, 71, 97, 101, 57, 107, 70, 23, 15,
      27,
    ],
    bar: [
      10, 97, 5, 64, 89, 59, 47, 76, 39, 26, 91, 3, 49, 100, 76, 48, 82, 95, 82, 42, 97, 63, 59, 45,
    ],
  },
  ITM008: {
    line: [
      38, 29, 26, 77, 41, 26, 36, 109, 77, 56, 19, 59, 38, 20, 13, 99, 91, 13, 54, 108, 114, 21,
      107, 57,
    ],
    bar: [
      56, 1, 6, 95, 67, 42, 62, 34, 94, 37, 44, 83, 48, 72, 82, 75, 45, 99, 61, 91, 78, 85, 79, 69,
    ],
  },
  ITM009: {
    line: [
      22, 19, 45, 98, 66, 70, 120, 34, 40, 18, 37, 119, 114, 110, 103, 28, 114, 74, 62, 16, 115, 81,
      119, 74,
    ],
    bar: [
      63, 80, 13, 29, 43, 74, 8, 83, 4, 32, 74, 37, 5, 10, 76, 92, 36, 13, 4, 75, 28, 0, 77, 77,
    ],
  },
  ITM010: {
    line: [
      71, 111, 71, 19, 56, 92, 57, 10, 74, 34, 11, 30, 103, 17, 117, 45, 10, 46, 99, 104, 73, 64,
      23, 39,
    ],
    bar: [
      46, 49, 42, 38, 84, 4, 39, 57, 18, 44, 73, 32, 54, 55, 34, 63, 68, 64, 75, 18, 41, 94, 82, 2,
    ],
  },
  ITM011: {
    line: [
      70, 97, 66, 42, 106, 63, 26, 105, 114, 71, 61, 45, 69, 109, 115, 64, 51, 17, 97, 53, 107, 35,
      40, 76,
    ],
    bar: [
      75, 90, 13, 7, 89, 84, 18, 80, 32, 92, 57, 35, 95, 34, 11, 84, 16, 49, 11, 82, 47, 80, 72, 58,
    ],
  },
  ITM012: {
    line: [
      46, 99, 78, 64, 104, 57, 67, 98, 69, 74, 33, 55, 97, 105, 68, 71, 89, 110, 109, 110, 51, 32,
      73, 17,
    ],
    bar: [
      65, 67, 20, 0, 46, 50, 39, 81, 85, 50, 70, 33, 84, 52, 10, 60, 76, 78, 8, 40, 12, 9, 7, 79,
    ],
  },
  ITM013: {
    line: [
      76, 30, 79, 71, 51, 37, 51, 109, 100, 107, 73, 99, 108, 11, 55, 58, 87, 50, 37, 23, 113, 89,
      111, 44,
    ],
    bar: [
      10, 17, 56, 79, 44, 7, 57, 91, 38, 30, 62, 86, 58, 72, 70, 78, 99, 50, 18, 16, 77, 85, 22, 0,
    ],
  },
  ITM014: {
    line: [
      100, 84, 104, 111, 62, 22, 91, 35, 37, 71, 58, 74, 61, 95, 38, 33, 103, 29, 66, 36, 93, 77,
      18, 108,
    ],
    bar: [
      90, 26, 66, 39, 30, 79, 61, 51, 17, 13, 40, 47, 41, 46, 33, 81, 81, 99, 13, 54, 22, 65, 48,
      45,
    ],
  },
  ITM015: {
    line: [
      12, 40, 68, 59, 11, 13, 86, 43, 116, 38, 68, 25, 20, 64, 112, 67, 120, 84, 50, 74, 42, 21, 50,
      116,
    ],
    bar: [
      41, 82, 75, 36, 85, 78, 51, 6, 76, 3, 29, 12, 25, 35, 45, 16, 93, 17, 33, 71, 19, 60, 0, 63,
    ],
  },
  ITM016: {
    line: [
      108, 47, 19, 33, 77, 64, 109, 41, 72, 41, 72, 90, 91, 74, 106, 65, 20, 112, 78, 93, 71, 97,
      93, 88,
    ],
    bar: [
      89, 55, 42, 35, 58, 70, 56, 78, 38, 42, 18, 93, 60, 64, 38, 44, 88, 3, 47, 53, 85, 5, 85, 96,
    ],
  },
  ITM017: {
    line: [
      100, 25, 80, 75, 116, 24, 96, 57, 60, 29, 28, 74, 40, 23, 13, 86, 79, 41, 41, 16, 25, 68, 41,
      21,
    ],
    bar: [
      88, 25, 96, 55, 56, 59, 54, 80, 100, 91, 50, 91, 29, 62, 29, 58, 8, 96, 81, 38, 31, 68, 24,
      40,
    ],
  },
  ITM018: {
    line: [
      18, 92, 28, 114, 108, 84, 23, 98, 69, 87, 31, 104, 68, 108, 115, 14, 81, 119, 82, 81, 89, 100,
      112, 115,
    ],
    bar: [
      93, 84, 67, 58, 80, 99, 7, 98, 54, 65, 85, 11, 8, 80, 84, 88, 54, 59, 42, 54, 69, 93, 79, 40,
    ],
  },
  ITM019: {
    line: [
      23, 26, 59, 57, 47, 93, 100, 104, 96, 108, 68, 78, 98, 42, 107, 88, 100, 30, 43, 17, 68, 98,
      18, 79,
    ],
    bar: [
      70, 66, 51, 71, 55, 67, 25, 20, 66, 49, 100, 87, 21, 73, 45, 60, 95, 34, 39, 45, 40, 3, 31, 5,
    ],
  },
  ITM020: {
    line: [
      36, 44, 84, 119, 55, 85, 30, 29, 99, 119, 104, 63, 81, 91, 65, 14, 12, 25, 106, 74, 69, 51,
      43, 91,
    ],
    bar: [
      28, 85, 10, 25, 22, 91, 48, 59, 57, 84, 12, 96, 0, 62, 48, 56, 37, 14, 46, 6, 90, 75, 22, 58,
    ],
  },
  ITM021: {
    line: [
      29, 10, 117, 10, 90, 45, 116, 100, 102, 39, 58, 29, 90, 13, 49, 119, 73, 47, 56, 116, 104, 48,
      55, 28,
    ],
    bar: [
      77, 25, 27, 77, 71, 25, 92, 67, 91, 53, 42, 28, 80, 100, 13, 65, 80, 85, 98, 35, 51, 62, 58,
      87,
    ],
  },
  ITM022: {
    line: [
      45, 10, 112, 56, 34, 112, 105, 68, 98, 83, 95, 39, 23, 27, 70, 25, 87, 27, 66, 47, 96, 19, 56,
      100,
    ],
    bar: [
      71, 12, 53, 98, 94, 60, 95, 79, 48, 73, 91, 45, 92, 13, 63, 77, 61, 55, 14, 54, 2, 77, 55, 49,
    ],
  },
  ITM023: {
    line: [
      98, 72, 101, 51, 106, 83, 55, 114, 51, 102, 92, 51, 60, 21, 51, 75, 38, 21, 43, 26, 40, 58,
      26, 112,
    ],
    bar: [
      95, 26, 54, 43, 26, 80, 52, 2, 0, 97, 82, 60, 79, 18, 16, 29, 28, 97, 17, 3, 56, 1, 51, 68,
    ],
  },
  ITM024: {
    line: [
      52, 55, 89, 106, 94, 58, 16, 55, 21, 28, 87, 11, 101, 62, 31, 67, 23, 69, 67, 31, 56, 104, 56,
      116,
    ],
    bar: [
      45, 90, 96, 37, 96, 94, 97, 71, 90, 44, 68, 95, 3, 40, 41, 37, 27, 74, 98, 72, 99, 33, 21, 67,
    ],
  },
  ITM025: {
    line: [
      37, 85, 26, 56, 82, 101, 68, 77, 32, 96, 53, 108, 82, 92, 37, 27, 86, 119, 78, 106, 78, 27,
      52, 16,
    ],
    bar: [
      45, 64, 60, 26, 60, 19, 63, 15, 85, 94, 83, 88, 63, 67, 9, 8, 54, 17, 34, 68, 40, 77, 6, 26,
    ],
  },
  ITM026: {
    line: [
      117, 113, 22, 96, 77, 105, 95, 34, 62, 22, 47, 72, 76, 87, 12, 43, 40, 29, 50, 16, 49, 99,
      105, 110,
    ],
    bar: [
      34, 67, 95, 89, 71, 94, 95, 26, 92, 64, 75, 62, 32, 26, 28, 25, 89, 55, 52, 0, 40, 77, 71, 29,
    ],
  },
  ITM027: {
    line: [
      29, 65, 118, 76, 71, 93, 103, 84, 96, 117, 99, 99, 108, 49, 117, 43, 103, 43, 48, 102, 63, 34,
      97, 114,
    ],
    bar: [
      21, 71, 25, 67, 33, 59, 31, 3, 7, 39, 55, 29, 7, 54, 75, 40, 26, 0, 88, 47, 72, 23, 84, 60,
    ],
  },
  ITM028: {
    line: [
      31, 106, 74, 61, 50, 36, 66, 52, 51, 13, 111, 63, 90, 26, 19, 115, 41, 95, 95, 82, 105, 36,
      38, 51,
    ],
    bar: [
      92, 72, 76, 83, 64, 21, 90, 73, 10, 32, 70, 2, 83, 76, 40, 34, 20, 0, 89, 37, 40, 16, 95, 91,
    ],
  },
  ITM029: {
    line: [
      33, 39, 18, 39, 25, 116, 89, 15, 69, 109, 25, 45, 23, 14, 99, 89, 111, 63, 55, 110, 30, 66,
      59, 93,
    ],
    bar: [
      78, 60, 44, 22, 48, 99, 79, 86, 57, 24, 63, 43, 94, 100, 1, 78, 33, 78, 52, 89, 27, 35, 18,
      70,
    ],
  },
  ITM030: {
    line: [
      70, 53, 62, 47, 118, 38, 31, 102, 100, 63, 99, 99, 24, 69, 45, 33, 48, 41, 21, 63, 27, 85, 31,
      62,
    ],
    bar: [
      60, 20, 0, 20, 41, 69, 78, 43, 3, 1, 67, 45, 18, 71, 64, 83, 16, 6, 69, 33, 5, 72, 78, 89,
    ],
  },
  ITM031: {
    line: [
      114, 119, 46, 30, 101, 37, 18, 97, 76, 44, 55, 36, 38, 99, 114, 28, 75, 23, 116, 112, 94, 55,
      104, 14,
    ],
    bar: [
      17, 72, 14, 69, 75, 11, 59, 42, 54, 38, 51, 49, 22, 82, 33, 55, 73, 68, 18, 21, 43, 57, 31, 8,
    ],
  },
  ITM032: {
    line: [
      95, 88, 111, 100, 84, 13, 11, 31, 98, 118, 94, 15, 15, 63, 90, 89, 54, 59, 30, 83, 20, 90, 97,
      70,
    ],
    bar: [
      95, 63, 4, 76, 42, 56, 16, 24, 7, 29, 62, 12, 69, 4, 96, 66, 20, 14, 86, 81, 54, 63, 84, 93,
    ],
  },
  ITM033: {
    line: [
      81, 113, 99, 33, 70, 103, 16, 61, 60, 25, 78, 115, 30, 81, 24, 20, 54, 99, 55, 38, 51, 28, 44,
      39,
    ],
    bar: [
      100, 0, 31, 77, 65, 52, 24, 40, 95, 30, 76, 93, 54, 11, 63, 97, 100, 2, 93, 92, 93, 40, 61,
      92,
    ],
  },
  ITM034: {
    line: [
      119, 94, 22, 96, 69, 73, 85, 70, 76, 50, 14, 72, 86, 113, 20, 110, 77, 52, 111, 68, 116, 108,
      16, 33,
    ],
    bar: [
      60, 43, 46, 24, 75, 63, 57, 94, 4, 51, 43, 18, 97, 85, 91, 56, 7, 69, 68, 36, 90, 55, 71, 34,
    ],
  },
  ITM035: {
    line: [
      30, 85, 87, 94, 84, 47, 84, 28, 105, 19, 55, 29, 104, 120, 110, 115, 41, 58, 114, 69, 17, 85,
      30, 104,
    ],
    bar: [
      98, 90, 53, 89, 70, 89, 35, 63, 22, 63, 25, 30, 10, 48, 52, 64, 2, 33, 86, 16, 85, 36, 81, 40,
    ],
  },
  ITM036: {
    line: [
      48, 20, 36, 88, 71, 98, 66, 17, 108, 77, 94, 50, 56, 90, 50, 98, 61, 117, 47, 14, 63, 18, 23,
      28,
    ],
    bar: [
      57, 86, 13, 93, 73, 71, 59, 71, 99, 14, 37, 92, 98, 95, 62, 21, 18, 40, 64, 61, 23, 74, 28,
      60,
    ],
  },
  ITM037: {
    line: [
      85, 16, 19, 120, 24, 71, 59, 97, 80, 88, 94, 39, 82, 99, 45, 55, 83, 66, 30, 23, 31, 100, 66,
      80,
    ],
    bar: [
      85, 20, 16, 65, 16, 89, 73, 9, 19, 88, 71, 44, 12, 72, 46, 39, 81, 26, 40, 27, 65, 78, 21,
      100,
    ],
  },
  ITM038: {
    line: [
      35, 47, 27, 32, 13, 120, 84, 10, 77, 91, 67, 64, 62, 62, 22, 20, 38, 53, 82, 73, 50, 84, 98,
      46,
    ],
    bar: [
      4, 4, 24, 15, 42, 78, 64, 52, 30, 59, 4, 21, 3, 73, 94, 46, 25, 99, 63, 28, 90, 21, 46, 67,
    ],
  },
  ITM039: {
    line: [
      32, 27, 52, 103, 42, 115, 28, 83, 31, 59, 91, 94, 115, 72, 48, 40, 21, 95, 44, 98, 28, 33, 27,
      29,
    ],
    bar: [
      59, 7, 19, 15, 1, 28, 47, 93, 33, 100, 72, 91, 11, 71, 76, 11, 37, 61, 81, 90, 96, 69, 88, 53,
    ],
  },
  ITM040: {
    line: [
      50, 12, 96, 84, 15, 10, 20, 92, 107, 46, 75, 100, 17, 65, 30, 23, 117, 105, 11, 72, 49, 31,
      54, 48,
    ],
    bar: [
      4, 1, 8, 73, 34, 15, 41, 78, 22, 76, 4, 81, 36, 19, 62, 16, 92, 16, 17, 14, 94, 29, 21, 15,
    ],
  },
  ITM041: {
    line: [
      47, 69, 40, 108, 88, 52, 12, 70, 34, 87, 51, 106, 102, 11, 56, 70, 83, 79, 26, 103, 84, 77,
      83, 114,
    ],
    bar: [
      41, 95, 0, 71, 61, 33, 64, 30, 53, 19, 58, 76, 32, 96, 77, 45, 97, 46, 21, 59, 67, 69, 20, 28,
    ],
  },
  ITM042: {
    line: [
      27, 60, 85, 44, 48, 109, 103, 104, 95, 28, 59, 108, 54, 105, 71, 25, 68, 67, 30, 62, 111, 118,
      33, 64,
    ],
    bar: [
      38, 76, 94, 16, 58, 21, 19, 95, 51, 2, 16, 21, 82, 19, 86, 0, 1, 9, 92, 79, 97, 79, 49, 14,
    ],
  },
  ITM043: {
    line: [
      32, 10, 59, 90, 22, 119, 75, 120, 114, 57, 46, 67, 100, 94, 66, 95, 42, 65, 88, 103, 45, 41,
      117, 23,
    ],
    bar: [
      19, 83, 78, 60, 63, 93, 40, 51, 87, 11, 27, 2, 67, 97, 34, 76, 80, 71, 26, 3, 88, 56, 28, 18,
    ],
  },
  ITM044: {
    line: [
      112, 56, 65, 90, 60, 109, 120, 50, 69, 81, 102, 28, 47, 75, 114, 45, 72, 52, 28, 82, 46, 82,
      66, 50,
    ],
    bar: [
      63, 10, 8, 3, 41, 46, 35, 48, 6, 43, 24, 35, 24, 36, 78, 48, 39, 8, 21, 87, 43, 95, 40, 2,
    ],
  },
  ITM045: {
    line: [
      89, 118, 104, 65, 58, 14, 104, 62, 75, 88, 11, 105, 106, 11, 28, 120, 73, 58, 19, 120, 33, 22,
      95, 41,
    ],
    bar: [
      43, 74, 70, 31, 41, 99, 19, 95, 91, 39, 100, 70, 65, 35, 10, 48, 46, 55, 76, 11, 79, 89, 17,
      12,
    ],
  },
  ITM046: {
    line: [
      103, 50, 91, 60, 74, 62, 80, 58, 30, 76, 83, 85, 19, 120, 80, 37, 102, 59, 10, 69, 95, 115,
      60, 79,
    ],
    bar: [
      46, 11, 17, 88, 83, 11, 39, 52, 66, 87, 76, 68, 33, 72, 62, 75, 67, 93, 20, 97, 40, 44, 50,
      63,
    ],
  },
  ITM047: {
    line: [
      60, 55, 66, 27, 39, 67, 46, 66, 15, 81, 61, 87, 38, 89, 119, 16, 68, 102, 77, 34, 68, 20, 117,
      37,
    ],
    bar: [
      59, 4, 98, 67, 91, 77, 86, 6, 65, 92, 26, 27, 20, 83, 32, 88, 85, 53, 47, 65, 63, 28, 49, 51,
    ],
  },
  ITM048: {
    line: [
      25, 69, 115, 13, 49, 31, 96, 36, 24, 55, 31, 71, 82, 74, 83, 108, 20, 36, 18, 120, 59, 34,
      102, 112,
    ],
    bar: [
      13, 83, 61, 53, 69, 81, 94, 77, 69, 0, 69, 62, 33, 63, 1, 51, 15, 58, 70, 47, 15, 88, 28, 49,
    ],
  },
};

export const itemTonGraphData: Record<
  string,
  { categories: string[]; line: number[]; point: number }
> = {
  ITM001: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [8, 8, 9, 9, 5, 2, 14, 9, 19, 19, 14, 14, 5, 11, 2, 15, 12, 15, 6, 11, 11, 2, 20, 10],
    point: 10,
  },
  ITM002: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      18, 29, 23, 29, 22, 21, 30, 17, 27, 26, 13, 23, 14, 24, 24, 26, 25, 22, 30, 23, 18, 10, 16,
      29,
    ],
    point: 20,
  },
  ITM003: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      26, 25, 24, 27, 39, 33, 33, 24, 33, 29, 39, 26, 28, 24, 33, 34, 33, 36, 39, 32, 35, 20, 38,
      25,
    ],
    point: 30,
  },
  ITM004: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      42, 49, 44, 35, 35, 47, 50, 49, 45, 39, 32, 36, 43, 41, 44, 38, 38, 50, 40, 41, 43, 48, 48,
      50,
    ],
    point: 40,
  },
  ITM005: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      43, 40, 44, 50, 54, 53, 53, 54, 57, 58, 59, 54, 51, 59, 55, 47, 60, 44, 52, 58, 59, 43, 44,
      42,
    ],
    point: 50,
  },
  ITM006: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      52, 69, 61, 57, 65, 58, 70, 50, 61, 50, 51, 57, 61, 67, 56, 54, 60, 57, 69, 56, 62, 65, 57,
      65,
    ],
    point: 60,
  },
  ITM007: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      79, 70, 68, 62, 69, 74, 74, 66, 62, 61, 77, 74, 70, 69, 71, 68, 80, 66, 65, 76, 60, 78, 75,
      75,
    ],
    point: 70,
  },
  ITM008: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      88, 78, 82, 78, 85, 88, 70, 83, 82, 86, 87, 75, 86, 70, 79, 88, 84, 72, 78, 84, 84, 85, 80,
      76,
    ],
    point: 80,
  },
  ITM009: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      89, 83, 96, 89, 100, 89, 90, 100, 94, 98, 82, 83, 90, 89, 81, 84, 90, 82, 87, 85, 88, 92, 81,
      96,
    ],
    point: 90,
  },
  ITM010: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      96, 97, 105, 95, 109, 103, 99, 107, 90, 109, 101, 90, 107, 102, 95, 107, 91, 106, 103, 109,
      102, 108, 90, 103,
    ],
    point: 100,
  },
  ITM011: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      106, 107, 102, 111, 108, 106, 100, 119, 116, 112, 110, 120, 116, 113, 111, 116, 112, 102, 115,
      108, 101, 109, 115, 119,
    ],
    point: 110,
  },
  ITM012: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      117, 117, 117, 111, 121, 123, 110, 119, 112, 121, 129, 110, 114, 111, 124, 119, 120, 128, 116,
      122, 125, 124, 128, 120,
    ],
    point: 120,
  },
  ITM013: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      134, 128, 129, 130, 130, 121, 125, 134, 138, 125, 137, 131, 131, 127, 125, 125, 131, 126, 121,
      124, 134, 139, 135, 137,
    ],
    point: 130,
  },
  ITM014: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      143, 132, 133, 135, 140, 133, 145, 135, 143, 148, 140, 144, 148, 130, 140, 140, 133, 130, 131,
      141, 150, 147, 133, 132,
    ],
    point: 140,
  },
  ITM015: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      158, 158, 154, 142, 153, 140, 141, 142, 157, 140, 142, 154, 148, 158, 149, 150, 151, 155, 147,
      146, 158, 145, 143, 147,
    ],
    point: 150,
  },
  ITM016: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      158, 157, 158, 154, 160, 155, 164, 159, 168, 155, 160, 151, 169, 159, 166, 157, 153, 161, 158,
      156, 158, 161, 164, 155,
    ],
    point: 160,
  },
  ITM017: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      178, 164, 166, 168, 167, 179, 177, 162, 172, 165, 160, 163, 167, 179, 168, 175, 162, 160, 170,
      171, 172, 177, 176, 173,
    ],
    point: 170,
  },
  ITM018: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      189, 190, 174, 173, 182, 183, 175, 181, 178, 172, 182, 178, 172, 172, 174, 183, 183, 179, 176,
      186, 177, 188, 170, 182,
    ],
    point: 180,
  },
  ITM019: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      185, 200, 183, 190, 184, 196, 194, 200, 196, 200, 188, 198, 195, 180, 194, 192, 186, 185, 195,
      195, 186, 189, 192, 196,
    ],
    point: 190,
  },
  ITM020: {
    categories: [
      "00-01",
      "01-02",
      "02-03",
      "03-04",
      "04-05",
      "05-06",
      "06-07",
      "07-08",
      "08-09",
      "09-10",
      "10-11",
      "11-12",
      "12-13",
      "13-14",
      "14-15",
      "15-16",
      "16-17",
      "17-18",
      "18-19",
      "19-20",
      "20-21",
      "21-22",
      "22-23",
      "23-24",
    ],
    line: [
      209, 196, 202, 209, 210, 191, 197, 207, 192, 206, 209, 198, 190, 201, 209, 200, 197, 201, 203,
      195, 196, 204, 205, 194,
    ],
    point: 200,
  },
};
